import {Player} from '@lottiefiles/react-lottie-player';
import {fixAssetsPathForLottieImages} from 'utils/lottie';

import data from './data.json';
import img_0 from './images/img_0.png';
import img_1 from './images/img_1.png';
import img_2 from './images/img_2.png';
import img_3 from './images/img_3.png';
import img_4 from './images/img_4.png';
import img_5 from './images/img_5.png';

export const IntSellAnimation = () => {
  /* eslint-disable @typescript-eslint/naming-convention */
  const images = {
    image_0: img_0,
    image_1: img_1,
    image_2: img_2,
    image_3: img_3,
    image_4: img_4,
    image_5: img_5,
  };
  /* eslint-enable @typescript-eslint/naming-convention */

  const amendedData = fixAssetsPathForLottieImages(data, images);

  return (
    <div style={{width: '100%', aspectRatio: `${data.w}/${data.h}`}}>
      <Player src={amendedData} autoplay loop />
    </div>
  );
};
